import { InjectionToken } from '@angular/core';

export namespace NDfModulePaypal {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_PAYPAL_OPTIONS');

    export interface IModuleOptions {
        review_path?: string;
    }
}
